import React from "react";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import useScrollToTop from "../../hooks/useScollToTop";
import ScrollIndicator from "../Home/ScrollIndicator";

import CommerceCard from "./components/CommerceCard";
import CommerceEmptyState from "./components/CommerceEmptyState";
import CommerceFilters from "./components/CommerceFilters";
import CommerceSkeleton from "./components/CommerceSkeleton";

import { COMMERCES_PAGE } from "./data/commercesUiData";
import { useCommercesPage } from "./hooks/useCommercesPage";

export default function CommercesPage() {
  useScrollToTop();

  const {
    loading,
    error,
    items,
    total,
    allTotal,
    categories,
    villes,
    filters,
    geo,
    expandedMapId,
    updateFilter,
    toggleCategory,
    toggleGeo,
    resetFilters,
    toggleMap,
    refresh,
  } = useCommercesPage();

  return (
    <>
      <PageHero
        title={COMMERCES_PAGE.title}
        imageUrl={COMMERCES_PAGE.heroImageUrl}
        crumbs={COMMERCES_PAGE.crumbs}
      />

      <ScrollIndicator />

      <main className="mx-auto max-w-[1240px] px-4 pb-16 pt-6 sm:px-6 md:pt-8">
        <PageSectionHeader
          eyebrow={COMMERCES_PAGE.eyebrow}
          title={COMMERCES_PAGE.title}
          description={COMMERCES_PAGE.description}
        >
          <div className="rounded-3xl border border-slate-200 bg-white/80 px-5 py-4 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Commerces actifs
            </p>
            <p className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {loading ? "…" : allTotal}
            </p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              référencé{allTotal > 1 ? "s" : ""}
            </p>
          </div>
        </PageSectionHeader>

        <div className="mt-5">
          <CommerceFilters
            loading={loading}
            filters={filters}
            geo={geo}
            categories={categories}
            villes={villes}
            total={total}
            allTotal={allTotal}
            onChange={updateFilter}
            onCategoryClick={toggleCategory}
            onGeoToggle={toggleGeo}
            onReset={resetFilters}
            onRefresh={refresh}
          />
        </div>

        {error && (
          <div className="mt-5 rounded-3xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-semibold text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300">
            Une erreur est survenue pendant le chargement des commerces.
          </div>
        )}

        <section className="mt-6">
          {loading ? (
            <CommerceSkeleton />
          ) : items.length > 0 ? (
            <div className="grid gap-5 lg:grid-cols-2">
              {items.map((commerce, index) => (
                <CommerceCard
                  key={commerce.id}
                  commerce={commerce}
                  delay={Math.min(index * 35, 180)}
                  isMapOpen={expandedMapId === commerce.id}
                  onToggleMap={() => toggleMap(commerce.id)}
                />
              ))}
            </div>
          ) : (
            <CommerceEmptyState onReset={resetFilters} />
          )}
        </section>
      </main>
    </>
  );
}